import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'quitaLetra'
})
export class QuitaLetraPipe implements PipeTransform {

    transform(value: string, posicion: number): string {
        if (!value) {
            return "-";
        }
        if (value.length - 1 >= posicion) {
            return this.replaceAt(value, posicion, '');
        }
        return value;
    }

    replaceAt(str, index, replacement) {
        return str.substr(0, index) + replacement + str.substr(index + 1);
    }
}